export default "__VITE_ASSET__ulZ8j4zb__"